export const REMOVE_ERROR_MESSAGE = 'REMOVE_ERROR_MESSAGE'
export function removeErrorMessageByType (typeToRemove) {
  return {
    type: REMOVE_ERROR_MESSAGE,
    payload: typeToRemove
  }
}
